export const config = {
    title: '人才招聘',
    desc: '非凡未来，敬在此刻，您准备好运用自己的卓越才能迎接新的机遇与挑战吗？从学习到创新，从专业到引领，从不凡到非凡。加入敬在，一起追求卓越，成就事业。',
    findPeople: {
        title: '我们寻找的人选',
        desc: '敬在的IT产品和高质服务是通过有效组织、深度整合的团队而提供，因此敬在寻求具备成长型思维模式、团队协作能力的伙伴加入，共同建设更美好的医疗信息化新世界。同时，敬在提供各类型岗位，让各有专长的伙伴都能在这里，实现自己定义的成功。',
        img: require('@/assets/images/about/img_job.png'),
    },
    findPeoples: [
        {
            title: '实习生招聘',
            info: '寻找对医疗信息化热情的实习生，共同参与医院智能化系统前沿实践。',
            btn:'查询岗位',
            tooltipBtnImg:require('@/assets/images/about/job_01.jpg'),
        },
        {
            title: '校园招聘',
            info: '提供您成长/学习和发展领导才能的职位，快来勇敢发现新世界。',
            btn:'查询岗位',
            tooltipBtnImg:require('@/assets/images/about/job_01.jpg'),
        },
        {
            title: '社会招聘',
            info: '敬在需要像您一样经验丰富的专业人士，敬在充分提供展示您才华的平台。',
            btn:'查询岗位',
            tooltipBtnImg:require('@/assets/images/about/job_01.jpg'),
        }
    ],
    welcome: {
        title: '欢迎您加入敬在',
        descLeft: '敬在是IT前沿技术推动者，是医院运营管理领域专家。是信息化智能研究员、软件工程师。亦是智慧医院建设的服务商和引领医疗行业数字化转变的先驱者。',
        descRight: '敬在的技术、团队和文化土壤，协助您发挥最大才能。向最优秀的人学习并获得赞赏，您将与不同团队并肩合作，从而习得专业知识、数智能力和深刻的行业洞察。敬在为您提供全面的培养机制和职业成长路径，在成为更好的自己这条道路上，敬在愿做您的同行者和领路人。',
    },
    get: {
        title: '您将获得',
        getList: [
            {
                img: require('@/assets/images/about/icon_job_01.svg'),
                title: '顶级医疗信息化项目和工作交流的机会',
            },
            {
                img: require('@/assets/images/about/icon_job_02.svg'),
                title: 'IT技术与管理咨询的双重能力',
            },
            {
                img: require('@/assets/images/about/icon_job_03.svg'),
                title: '国际化管理经验和战略视野',
            },
            {
                img: require('@/assets/images/about/icon_job_04.svg'),
                title: '对运营管理关键决策产生重要影响',
            },
            {
                img: require('@/assets/images/about/icon_job_05.svg'),
                title: '在上升行业快速成长且获得发展机遇',
            },
        ]
    },
    problem: {
        title: '关于职业发展，您可能关心的问题',
        desc: '以下是针对招聘过程中求职者/应届生，普遍关心的职业选择问题与职业发展困惑，我们精选并邀请了敬在资深HRBP团队进行的专业解答。这些问题涵盖了从工作机会评估到个人职业规划的多个方面，旨在帮助求职者做出更加明智的职业决策。',
        list: [
            {
                fileName:'抉择之力.js',
                title: '抉择之力 vs 奋斗之汗：谁才是成功的关键？',
                info:'抉择之力vs奋斗之汗：谁才是成功的关键？在人生的旅途中，我们常常站在十字路口，左手是选择，右手是努力，心中不免产生疑问：究竟是努力更重要，还是选择更为关键？对于刚加入敬在信息的各位新人而言，这个问题的答案将深刻影响你们的职业发展轨迹。选择的魔力：定位人生的方向我们常常听到这样一句话：“人生最重要的不是你所处的位置，而是你所朝的方向。”这其中的“方向”，便是我们生活中所做出的选择。正确的选择，能够让我们事半功倍，快速接近目标；而错误的选择，则可能让我们陷入困境，甚至南辕北辙。以我们敬在信息为例，公司成立于2019年，选择了医院智慧管理综合解决方案这一赛道。这一选择不是偶然的冲动，而是基于对医疗行业痛点的深刻洞察。随着国家医改不断深化，越来越多的医院明显意识到了运营管理的重要性和必要性。这个选择让我们站在了时代的风口上，成为国内医疗信息化专业厂商，更是国内最早的HRP（医院资源规划）专业团队。选择如同指南针，指引着努力的方向。一个正确的选择，能够让努力的价值成倍放大；而一个错误的选择，则可能使努力付诸东流。正如管理大师德鲁克所说：“效率是正确地做事，成效是做正确的事。”当诺基亚坚持塞班系统时，苹果选择触控屏的革命性路径，这种战略选择的价值远超千万小时的代码编写。努力的力量：将选择转化为现实然而，光有选择还不够。如果没有努力的付出，再好的选择也只是空中楼阁，无法落地生根。努力，是实现梦想的桥梁，是通往成功的必经之路。在敬在信息，我们见证了努力如何将选择转化为现实。公司团队十多年来一直专注在医院运营管理领域，服务过很多国内知名大型三甲医院。每位成员都有着深厚的服务基因，这也形成了敬在信息重视实施效果的服务理念。这种坚持不懈的努力，使得我们的产品和服务覆盖全国20多个省市、百余家医疗机构及卫生主管部门，每天为无数医疗管理者提供支持。当爱迪生被问及发明电灯的失败次数时，他回答：“我没有失败，我只是发现了一万种不适合做灯丝的材料。”这种将挫折转化为阶梯的努力精神，在当今职场依然闪耀。在篮球场上，科比·布莱恩特“凌晨四点洛杉矶”的故事广为流传。这位传奇球员在职业生涯中坚持每天投篮2000次，这种近乎偏执的努力让天赋转化为传奇。敬在信息：选择与努力的完美融合在敬在信息，我们深信选择与努力是相辅相成的。公司的发展历程就是这一理念的最佳证明。我们选择了黄金赛道。医疗信息化是国家政策力挺的领域，在公立医院绩效考核、医保支付改革等倒逼之下，“智慧”赋能下的医院管理迎来蜕变。敬在信息凭借前瞻性的战略选择，提前布局开发产品，持续领跑行业。我们努力打造卓越产品。敬在信息的产品从更多先进技术应用入手，满足不同用户的需求。以发票处理为例，敬在的产品集成OCR、RPA等技术，把非结构化的数据变成结构化的数据，流程机器人自动处理，这些业务处理的工作量就完全由敬在产品完成了，医院财务人员的工作效率得到了显著提升。我们秉持“智慧方案+智能产品+敬在服务”的业务闭环。在实践中，我们发现医院管理层关注管理价值的同时，用户最关心的是产品的易用性。敬在的产品追求从“好操作”到“不用操作”的智能化体验，这种产品友好性、智能性、设计感等优势正逐步体现出来。新人们的双翼：在公司平台上展翅高飞对于刚加入敬在信息的各位新人，你们已经做出了一个明智的选择。你们选择了一个处于上升期的行业，一家有发展潜力的公司，一个充满希望的职业起点。公司为你们提供了清晰的成长通道：从基层到管理层，从执行者到决策者。现在，需要的是你们的不懈努力。敬在信息为员工提供了完善的培训体系和晋升机制。我们有“敬在学院”，提供免费带薪的专项培训；我们为每一位员工提供良好的职业生涯规划培训及公平公正公开晋升发展机会。心理学中的“目标设定理论”揭示：具体挑战性目标（选择）与持续反馈机制（努力）的结合，能产生1+1>2的效果。在敬在信息，我们为员工提供明确的发展路径（选择）和全面的支持体系（努力），帮助大家在这双翼的助力下飞得更高更远。成就未来：让选择与努力协同共舞站在人生的甲板上回望，那些伟大的航程从来不是非此即彼的选择。就像郑和下西洋的宝船，既需要精确的星盘导航（选择），也离不开水手们昼夜不停的划桨（努力）。选择和努力的关系，犹如种子与土壤。选择是种子，决定了生长的方向；努力是土壤，提供了成长的养分。二者相辅相成，缺一不可。在人工智能时代，这种平衡显得尤为重要：算法工程师既要选择正确的模型架构（选择），又需要数万次参数调优（努力）。在敬在信息的大家庭里，我们已经为你们铺就了发展的跑道。你们选择了医疗信息化这一充满前景的行业，加入了敬在信息这一成长型企业。抉择之力决定方向，奋斗之汗决定高度。在敬在信息的舞台上，让选择与努力成为你们职业生涯的双翼，助力你们翱翔于职场天际，共同创造医疗智慧管理的新未来！',
                content: ''
            },
            {
                fileName:'压力与挑战.js',
                title: '如何应对工作中的压力与挑战？',
                info:'如何应对工作中的压力与挑战？在现代职场中，压力与挑战如同影子般伴随我们的职业生涯。面对医院智慧管理这一快速发展的领域，如何在压力下保持韧性、化挑战为机遇，不仅是个人成长的关键，更是职业发展的重要课题。理解职场压力：不是敌人，而是盟友适当的压力是维持正常身心功能活动的必要条件。根据“拍球效应”，拍球时用的力越大，球就弹得越高——在人身上也同样如此：承受的压力越大，潜能发挥程度越高。心理学中的“压力与表现倒U型曲线”说明，压力太小时不利于激发人的动力，导致表现变差；压力过大时会压抑潜力；而压力强度适中时，行动力可得到迅速提升。在敬在信息，我们面对的是医院运营管理领域的复杂挑战，每一次系统上线、每次医院流程优化都是一次压力测试。正是这些挑战，推动我们不断突破能力边界，实现个人与公司的共同成长。有效应对：构建个人减压工具箱给任务做减法。当面对繁重的工作任务时，核心是“给任务减负”。把大型任务拆分成小目标，每天完成1-2件小步骤，成就感会慢慢积累。工作与生活的平衡艺术。主动管理自己的情绪，注重业余生活，不要把工作上的压力带回家。留出休整的空间：与他人共享时光、阅读、冥想、听音乐、参与体力劳动都是获得内心安宁的方式。规律作息、高质量的睡眠、健康的饮食习惯和适度运动是维持心理平衡的基础。建立支持网络。不要试图一个人承担所有压力。平时积极改善人际关系，加强与上级、同事的沟通。心态调整：改变视角，重塑体验接纳而非抗拒。先“看见”并接纳自己的情绪，不要强迫自己硬扛下去。情绪就像天气变化一样自然，没有必要因此责备自己。困难是一道分水岭，映照个人修养，克服了就会有一番新天地，事业就能达到新境界。从“不得不”到“我选择”。把“不得不做”变成“我选择做”，比如“这份工作能让我积累行业经验”“这个项目能提升我的专业能力”，如此可以重新找到工作的意义。在敬在信息，我们相信培养对工作的热爱，不断寻找兴奋点，是应对压力的长效良药。组织支持：敬在信息的韧性培养体系在敬在信息，我们不仅关注员工的工作表现，更重视心理健康这一“隐形生产力”。我们为员工提供清晰的职业发展通道，帮助每个人在面对挑战时看到成长路径。公司倡导开放沟通的文化，当压力过大时可以寻求主管的协助，而不是一个人承担所有压力。我们定期组织团队建设活动，加强同事间的交流，构建互信互助的工作环境。成长在压力中绽放压力与挑战是现代职场的常态，尤其在医院智慧管理这一充满机遇的领域。真正的职场强者不是没有压力的人，而是懂得如何将压力转化为动力的人。在敬在信息，我们相信每一次系统上线的紧张、每次客户需求的挑战、每个技术难题的攻克，都是锻造专业能力的熔炉。压力不是前进的阻力，而是成长的动力。“困难是一道坎，是一道分水岭。就像鲤鱼跳龙门，跳过去就是一片新天地，进入一种新境界。”在敬在信息的平台上，让我们以智慧和韧性面对工作中的每一次挑战，共同推动中国医疗智慧管理的发展，实现个人与企业的共同超越。在敬在信息，我们不仅提供工作，更提供成长的舞台。在这里，每一次压力都是蜕变的机会，每一个挑战都是进步的阶梯。让我们携手前行，在应对压力与挑战中，遇见更好的自己。',
                content: ''
            },
        ]
    },
}